export const DASHBOARD_SECTIONS = [
  { id: "kpis", title: "Summary" },
  { id: "tasks", title: "Tasks" },
  { id: "followups", title: "Follow-ups" },
];

export const KPI_META = [
  { id: "followupToday", label: "Follow-ups today" },
  { id: "followupOverdue", label: "Overdue" },
  { id: "followupUpcoming", label: "Upcoming" },
  { id: "inquiries", label: "Inquiries" },
  { id: "tasks", label: "Tasks" },
  { id: "payment", label: "Payment recovery" },
  { id: "cases", label: "GST cases" },
  { id: "customers", label: "Customers" },
  { id: "communications", label: "Communications" },
  { id: "employees", label: "Employees" },
  { id: "roles", label: "Roles" },
];

export const DEFAULT_KPI_ORDER = KPI_META.map((item) => item.id);

export const defaultDashboardLayout = () => ({
  sections: DASHBOARD_SECTIONS.map((section) => ({ id: section.id, visible: true })),
  kpiOrder: [...DEFAULT_KPI_ORDER],
  hiddenKpis: [],
});

export const normalizeDashboardLayout = (input) => {
  const fallback = defaultDashboardLayout();
  const allowed = new Set(DASHBOARD_SECTIONS.map((section) => section.id));
  const seen = new Set();
  const sections = [];
  (Array.isArray(input?.sections) ? input.sections : []).forEach((item) => {
    if (!item?.id || !allowed.has(item.id) || seen.has(item.id)) return;
    seen.add(item.id);
    sections.push({ id: item.id, visible: item.visible !== false });
  });
  fallback.sections.forEach((item) => {
    if (!seen.has(item.id)) sections.push(item);
  });
  const kpiAllowed = new Set(DEFAULT_KPI_ORDER);
  const kpiOrder = [
    ...(Array.isArray(input?.kpiOrder) ? input.kpiOrder : []),
    ...fallback.kpiOrder,
  ].filter((id, index, list) => kpiAllowed.has(id) && list.indexOf(id) === index);
  const hiddenKpis = (Array.isArray(input?.hiddenKpis) ? input.hiddenKpis : []).filter(
    (id, index, list) => kpiAllowed.has(id) && list.indexOf(id) === index
  );
  return { sections, kpiOrder, hiddenKpis };
};

export const layoutStorageKey = (userId) => `jm-dashboard-layout:${userId || "anon"}`;

export const readStoredLayout = (userId) => {
  try {
    const raw = localStorage.getItem(layoutStorageKey(userId));
    return raw ? normalizeDashboardLayout(JSON.parse(raw)) : defaultDashboardLayout();
  } catch (error) {
    return defaultDashboardLayout();
  }
};

export const writeStoredLayout = (userId, layout) => {
  try {
    localStorage.setItem(layoutStorageKey(userId), JSON.stringify(normalizeDashboardLayout(layout)));
  } catch (error) {
    // ignore quota / private mode
  }
};

export const reorderList = (list, startIndex, endIndex) => {
  const next = Array.from(list);
  const [moved] = next.splice(startIndex, 1);
  next.splice(endIndex, 0, moved);
  return next;
};
